// Central content + asset map for the landing page.

export const CALENDLY_URL = "https://calendly.com/drpowell-ascendingtrends";


export const ASSETS = {
  heroPortrait:
    "https://customer-assets.emergentagent.com/job_testimonials-9/artifacts/mzitcz4e_IMG_1871.webp",
  standingPortrait:
    "https://customer-assets.emergentagent.com/job_testimonials-9/artifacts/n1hkryjx_IMG_1879.webp",
  laptopPortrait:
    "https://customer-assets.emergentagent.com/job_testimonials-9/artifacts/lmrhgx2p_IMG_1911.webp",
  readingSession:
    "https://customer-assets.emergentagent.com/job_testimonials-9/artifacts/9183r595_IMG_4082.webp",
  video: "/media/joanne.mp4",
  videoPoster: "/media/joanne-poster.jpg",
  stepUpLogo:
    "https://customer-assets.emergentagent.com/job_testimonials-9/artifacts/iocito04_SUFS_EMA_MarkerplaceProvider_Badge_LG-01.webp",
  familyHighFive:
    "https://customer-assets.emergentagent.com/job_testimonials-9/artifacts/z4qps4gr_Screenshot%202026-07-11%20at%2010.43.59%E2%80%AFPM.png",
  meetFamily: "/media/meet-family.webp",
  cohortStock: "/media/lab-behavioral.png",
  parentsStock: "/media/lab-parent.webp",
  sandTexture:
    "https://images.unsplash.com/photo-1714636608872-048fc9231892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHx3YXJtJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwYmVpZ2UlMjBzYW5kfGVufDB8fHx8MTc4MzgxNTk4NHww&ixlib=rb-4.1.0&q=85",
  clayTexture:
    "https://images.unsplash.com/photo-1628965882741-570e75becd5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMHRlcnJhY290dGElMjBjbGF5JTIwdGV4dHVyZXxlbnwwfHx8fDE3ODM4MTU5ODR8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "About", href: "#about" },
  { label: "My Services", href: "#paths" },
  { label: "Community Cohorts", href: "#labs" },
  { label: "The Method", href: "#method" },
  { label: "Connect", href: "#connect" },
];

export const ASCEND = [
  {
    letter: "A",
    title: "Assess",
    body: "Identify values, strengths, barriers, behavioral patterns, and the current environment before anything else.",
  },
  {
    letter: "S",
    title: "Strategize",
    body: "Clarify purpose, define measurable objectives, and design the systems that quietly make success inevitable.",
  },
  {
    letter: "C",
    title: "Create",
    body: "Build the habits, leadership practices, and sustainable routines that hold under real-world pressure.",
  },
  {
    letter: "E",
    title: "Execute",
    body: "Implement with intention, accountability, and behavioral precision — not willpower.",
  },
  {
    letter: "N",
    title: "Navigate",
    body: "Adapt to obstacles, transitions, and changing seasons of life without losing momentum.",
  },
  {
    letter: "D",
    title: "Demonstrate",
    body: "Measure progress, celebrate outcomes, and refine the next phase. If it matters, we should be able to measure it.",
  },
];

export const PATHS = [
  {
    id: "professionals",
    kicker: "For Leaders & Professionals",
    tabLabel: "Leaders & Professionals",
    tabSub: "Behavior analysts & leaders",
    title: "You're a behavior analyst ready for your next chapter.",
    body: "Move from expertise to clarity, confidence, and influence — beyond traditional clinical practice.",
    services: ["strategy_session", "ongoing_partnership"],
    funnel: {
      name: "The Behavioral Leadership Lab",
      href: "#labs",
      note: "12-week cohort · begins September 2026",
    },
    image: "laptopPortrait",
  },
  {
    id: "organizations",
    kicker: "For Organizations",
    tabLabel: "Organizations",
    tabSub: "Teams & founders",
    title: "You lead a small team that deserves a sharper strategy.",
    body: "Strategic planning, leadership development, and culture work grounded in behavioral science.",
    services: ["strategy_session", "ongoing_partnership"],
    funnel: null,
    image: "standingPortrait",
    objectPosition: "center 15%",
  },
  {
    id: "families",
    kicker: "For Families",
    tabLabel: "Families",
    tabSub: "Parents & caregivers",
    title: "You're raising a child and leading your most important team.",
    body: "Family leadership coaching and evidence-based reading support, designed around your child.",
    services: ["strategy_session", "homeschool_strategy", "reading_intervention", "evaluation_assessment"],
    funnel: {
      name: "The Parent Leadership Lab",
      href: "#labs",
      note: "8-week cohort · begins September 2026",
    },
    image: "readingSession",
  },
];

export const SERVICE_COPY = {
  strategy_session: {
    name: "Strategy Session",
    duration: "60 minutes",
    tagline: "One focused, high-leverage conversation.",
    features: [
      "Pre-session reflection questionnaire",
      "60-minute strategy conversation",
      "Personalized action roadmap",
      "Follow-up summary & next steps",
    ],
  },
  ongoing_partnership: {
    name: "Ongoing Partnership",
    duration: "3-month minimum",
    tagline: "Sustained 1:1 coaching, week over week.",
    features: [
      "Private coaching sessions",
      "Between-session email support",
      "Curated resources & recommendations",
      "Progress review & strategic roadmap",
    ],
  },
  homeschool_strategy: {
    name: "Homeschool Strategy Session",
    duration: "Two 30-min sessions",
    tagline: "Personalized guidance for designing a homeschool that fits your family.",
    paragraphs: [
      "Choosing the right educational path for your family is one of the most meaningful decisions you'll make. As both a homeschooling mom and the leader of a thriving hybrid homeschool community, I understand the joys, challenges, and countless decisions that come with creating a personalized educational experience. Whether you're exploring homeschooling for the first time, transitioning from traditional school, considering a hybrid model, selecting curriculum, or simply looking for guidance and encouragement, I provide practical, evidence-informed coaching tailored to your family's goals.",
      "My role is to come alongside your family with experience, strategy, and support—helping you intentionally design a learning environment where everyone can flourish.",
    ],
  },
  reading_intervention: {
    name: "Individualized Reading Intervention",
    duration: "10 weeks",
    tagline: "Evidence-based, individualized literacy support.",
    features: [
      "Review of existing academic and evaluation information",
      "Individualized reading-skills assessment",
      "Reading fluency and foundational-skills intervention",
      "Data-informed instructional planning",
      "Parent consultation and coaching",
      "Progress monitoring",
      "Coordination with a child's support team, when appropriate",
    ],
  },
  evaluation_assessment: {
    name: "Evaluation & Assessment",
    duration: "By consultation",
    tagline: "Understand your child's full learning profile.",
    paragraphs: [
      "Some learners benefit from a comprehensive evaluation before or alongside educational intervention. When appropriate, we're happy to connect families with our trusted evaluation partners who provide evidence-based, standardized assessments to better understand a child's academic, communication, social-emotional, behavioral, and executive-functioning strengths and needs.",
      "Because every learner is unique, the type of assessment recommended depends on your child's individual goals and areas of concern. Assessment fees are determined by the scope and type of evaluation and are provided directly by the evaluating practice following an initial consultation.",
    ],
  },
};

export const LABS = [
  {
    id: "behavioral",
    audience: "For behavior analysts",
    name: "The Behavioral Leadership Lab",
    duration: "12 weeks",
    seats: "20–30 professionals",
    starts: "September 2026",
    tuition: 1500,
    holdPackage: "hold_my_spot",
    tuitionPackage: "behavioral_leadership_lab",
    leadPath: "professionals",
    blurb:
      "A leadership laboratory where behavior analysts learn, experiment, and apply behavioral science to real leadership challenges — beyond the clinic.",
    includes: [
      "Weekly live coaching",
      "Guest experts",
      "Community & office hours",
      "Templates, workbooks & recorded lessons",
    ],
    image: "cohortStock",
    objectPosition: "50% 32%",
  },
  {
    id: "parent",
    audience: "For parents",
    name: "The Parent Leadership Lab",
    duration: "8 weeks",
    seats: "10 parents",
    starts: "September 2026",
    tuition: 1000,
    holdPackage: "parent_hold_my_spot",
    tuitionPackage: "parent_leadership_lab",
    leadPath: "families",
    blurb:
      "An intimate cohort for parents who want to lead their families with intention — bringing behavioral science home in a warm, practical way.",
    includes: [
      "Weekly live sessions",
      "Parent strategy tools",
      "Peer community",
      "Practical, home-ready routines",
    ],
    image: "parentsStock",
    objectPosition: "50% 72%",
  },
];
